<template>
	<v-app>
		<div v-if="$route.meta && $route.meta.layout === 'fullScreen'">
			<router-view v-slot="{ Component, route }" :key="$route.fullPath">
				<MaintenanceMode />
				<v-slide-x-transition>
					<div :key="route.fullPath">
						<component :is="Component" />
					</div>
				</v-slide-x-transition>
			</router-view>
		</div>
		<Landers
			v-else-if="
				($route.meta.public && $route.meta.lander) || $route.fullPath === '/' && !isNative
			"
		>
			<router-view v-slot="{ Component, route }" :key="$route.fullPath">
				<v-slide-x-transition>
					<div :key="route.fullPath">
						<component :is="Component" />
					</div>
				</v-slide-x-transition>
			</router-view>
		</Landers>
		<Public v-else-if="$route.meta.public">
			<router-view v-slot="{ Component, route }" :key="$route.fullPath">
				<MaintenanceMode />
				<v-slide-x-transition>
					<div :key="route.fullPath">
						<component :is="Component" />
					</div>
				</v-slide-x-transition>
			</router-view>
		</Public>
		<Authorized
			v-else-if="
				(!$route.meta.public && Object.keys($route?.meta || {}).length >= 1 )|| isNative
			"
		>
			<router-view v-slot="{ Component, route }" :key="$route.fullPath">
				<MaintenanceMode />
				<v-slide-x-transition>
					<div :key="route.fullPath">
						<component :is="Component" />
					</div>
				</v-slide-x-transition>
			</router-view>
		</Authorized>
		<div v-else>
			<p id="unknown-wrapper" style="opacity: 0.01">
				UNKNOWN WRAPPER DEFINED<br >
				{{ $route.path }}
				<br >
				{{ $route }}
			</p>
		</div>
		<AllPiniaModals />
		<v-footer v-if="$route.meta.straightScoreFooter" app theme="dark">
			<div
				class="d-flex justify-space-between align-center"
				style="width: 100%"
			>
				<span>
					&copy; {{ new Date().getFullYear() }} Straight Score. All rights
					reserved.
				</span>
				<v-btn
					v-if="$vuetify.display.smAndUp"
					href="https://club.shootpro.cloud/login"
					variant="text"
					size="small"
				>
					Club Login
				</v-btn>
			</div>
		</v-footer>
	</v-app>
</template>

<script>
import Public from './layouts/Public.vue';
import { mapActions, mapState } from 'pinia';
import { authorizationStore } from '@/store/authorization';
import Authorized from './layouts/Authorized.vue';
import AllPiniaModals from './components/PiniaModals/allPiniaModals.vue';
import MaintenanceMode from './components/maintenanceMode.vue';
import Landers from './layouts/Landers.vue';
import { useSeoMeta } from '@unhead/vue';
import { Capacitor } from '@capacitor/core';

export default {
	name: 'App',

	components: {
		Public,
		Authorized,
		AllPiniaModals,
		MaintenanceMode,
		Landers,
	},

	data: () => ({
		isNative: false
	}),

	computed: {
		...mapState(authorizationStore, ['userId']),
	},

	async created() {
		this.initAuth().then((isAuthorized) => {
			if (!isAuthorized) {
				console.warn('[Init] Not authorized.');
			}
		});

		window.addEventListener('keydown', (ev) => {
			if (ev.altKey && ev.key === '[') {
				this.$router.push('/debug');
			}
		});
		useSeoMeta({
			applicationName: 'ShootPro Cloud',
			author: 'Straight Score LLC',
			creator: 'Straight Score LLC',
			title:
				'ShootPro Cloud - Modern Cashiering and Scoring for Trapshooting Tournaments',
			description:
				'Discover ShootPro Cloud, a modern cashiering and scoring platform for ATA and PITA trapshooting tournaments. Streamline operations with real-time updates, live scores, and more.',
		});
		this.isNative = Capacitor.isNativePlatform();
	},

	methods: {
		...mapActions(authorizationStore, {
			initAuth: 'init',
		}),
	},
};
</script>
<style>
html {
	touch-action: manipulation;
}
</style>
<style scoped>
#unknown-wrapper {
	opacity: 0.01;
	animation: fadeIn 5s forwards;
}

@keyframes fadeIn {
	0% {
		opacity: 0.01;
	}
	1% {
		opacity: 0;
	}
	99% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}
</style>
